import { productCategoryIdFormat } from "@redotech/redo-model/ids";
import * as z from "zod/v4";

const ProductCategorySchema_ = z.object({
  id: productCategoryIdFormat.schema,
  name: z.string(),
});

export const ProductCategorySchema: z.ZodType<ProductCategory> =
  ProductCategorySchema_;
export interface ProductCategory
  extends z.infer<typeof ProductCategorySchema_> {}

export const getProductCategories = {
  name: "getProductCategories" as const,
  input: z.object({
    categoryId: productCategoryIdFormat.schema.nullable(),
  }),
  output: z.object({
    categories: z.array(ProductCategorySchema),
    parent: ProductCategorySchema.nullable(),
  }),
};
